import React from 'react';
import {
  makeStyles,
  Backdrop,
  Fade,
  Modal as MUIModal,
  Typography
} from "@material-ui/core";
import { Button } from './Components';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    maxWidth: '420px',
    margin: '0 auto',
    boxSizing: 'border-box',
  },

  modalPaper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },

  modalTitle: {
    textAlign: "center",
    width: '100%',
    marginTop: 10,
    marginBottom: 20,
    fontWeight: "bold",
  },

  modalDescription: {
    marginBottom: 20,
    fontSize: '16px',
    fontWeight: 'bold',
    textAlign: 'justify'
  },

  modalButtonContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-around",
    width: "100%",
  },
}));

export const FeedbackModal = ({
  id,
  title,
  description,
  button,
  open,
  disabled = false,
  onClick,
  extraButton = ""
}) => {
  const classes = useStyles();

  return (
    <MUIModal
      aria-labelledby={`${id}-modal-title`}
      aria-describedby={`${id}-modal-description`}
      className={classes.modal}
      open={open}
      closeAfterTransition
      disableBackdropClick
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.modalPaper}>
          <Typography
            id={`${id}-modal-title`}
            style={{
              color: title?.color ?? '#00A859',
            }}
            className={classes.modalTitle}
            variant='h6'
          >
            {title?.text}
          </Typography>
          <Typography
            id={`${id}-modal-description`}
            style={{
              color: description?.color ?? '#808080',
            }}
            className={classes.modalDescription}
          >
            {description?.text}
          </Typography>
          <div className={classes.modalButtonContainer}>
            <Button
              style={{
                backgroundColor: button?.backgroundColor ?? '#FF0066',
                width: 200
              }}
              disabled={disabled}
              onClick={onClick}
            >
              {button?.text}
            </Button>
            {
              extraButton ?
                <Button
                  style={{
                    backgroundColor: "#9e9e9e"
                  }}
                  disabled={disabled}
                  onClick={onClick}
                >
                  {extraButton}
                </Button>
                : null
            }
          </div>
        </div>
      </Fade>
    </MUIModal>
  )
};